import { Injectable } from "@angular/core";
import { AppAddress, ApiAppAddress, apiAppAddressToAppAddress as clean } from "./app-address";
import { ApiResourceService } from "../api-resource.service";
import { ApiSessionService } from "../../api-session.service";
import { ApiAction, ApiBrowseAction, ApiEditAction } from "../../api-actions";
import { sessionId } from "../../apiParams/session-id";
import { ApiStateStoreService } from "../../api-state-store.service";
import { OnsipApiResponse, extractData } from "../../apiResponse/response-body-new";
import { getApiActionName } from "../../onsip-api-action-new";
import { Observable } from "rxjs";
import { ParameterValue } from "../../util/api-action-description";
import { organizationId } from "../../apiParams/organization-id";
import { ApiPromiseState, ApiPromiseStateService } from "../../api-promise-state.service";

@Injectable({ providedIn: "root" })
export class AppAddressService extends ApiResourceService<AppAddress> {
  constructor(
    session: ApiSessionService,
    store: ApiStateStoreService,
    promiseState: ApiPromiseStateService
  ) {
    super(session, store, promiseState, "AppAddress", "addressId");
  }

  appAddressBrowse(Limit?: number): ApiPromiseState<AppAddress> {
    this.dispatcher.next({
      parameters: {
        Action: ApiAction.AppAddressBrowse,
        SessionId: this.store.state.pipe(sessionId()),
        OrganizationId: this.store.state.pipe(organizationId()),
        Limit: Limit || 25000
      }
    });
    return this.promiseState.toPromise(ApiAction.AppAddressBrowse);
  }

  // can also supply Address param- make a separate function header if needed
  appAddressRead(AddressId: string | Observable<string>): ApiPromiseState<AppAddress> {
    this.dispatcher.next({
      parameters: {
        Action: ApiAction.AppAddressRead,
        SessionId: this.store.state.pipe(sessionId()),
        AddressId
      }
    });
    return this.promiseState.toPromise(ApiAction.AppAddressRead);
  }

  /**
   *
   * @param Address - this is the sip address of the app being modified
   * @param extraParams - there are only 3 options params:
   * 1. Username - this is used to modified the username portion of the sip address
   * 2. Name - this is used to modify the display name of the app
   * 3. FailoverAddress - this is set a failover sip address if connection to the app sip address fails
   */
  appAddressEdit(
    Address: string,
    extraParams: Record<string, ParameterValue> = {}
  ): ApiPromiseState<AppAddress> {
    this.dispatcher.next({
      parameters: {
        Action: ApiEditAction.AppAddressEdit,
        SessionId: this.store.state.pipe(sessionId()),
        Address,
        ...extraParams
      }
    });
    return this.promiseState.toPromise(ApiEditAction.AppAddressEdit);
  }

  // TODO the rest of the actions

  protected reducer(response: OnsipApiResponse): void {
    const action = getApiActionName(response);
    switch (action) {
      case ApiEditAction.AppAddressEdit:
      case ApiAction.AppAddressRead:
        this.store.mergeStateUpdate(
          this.resourceName,
          ApiResourceService.arrayToRecord(
            [extractData<ApiAppAddress>(response, action, "AppAddress")].map(clean),
            this.indexKeyName
          ),
          action
        );
        break;
      case ApiBrowseAction.AppAddressBrowse:
        this.store.mergeStateUpdate(
          this.resourceName,
          ApiResourceService.arrayToRecord(
            extractData<Array<ApiAppAddress>>(response, action, "AppAddress", "AppAddresses").map(
              clean
            ),
            this.indexKeyName
          ),
          action
        );
        break;
    }
  }
}
